import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { pageUrl } from '@/constants/url'
import ServiceLayout from './components/services/serviceList/serviceLayout'

const PackagesPage = lazy(() => import('./pages/packages'))
const ProductsPage = lazy(() => import('./pages/products'))
const ServiceListPage = lazy(() => import('./pages/services/serviceList'))
const BundleListPage = lazy(() => import('./pages/services/bundleList'))
const ServiceForm = lazy(() => import('./pages/services/serviceForm'))
const VouchersPage = lazy(() => import('./pages/vouchers/index'))
export const catalogRoutes = () => {
  return (
    <>
      <Route path={pageUrl.packages} element={<PackagesPage />} />
      <Route path={pageUrl.products} element={<ProductsPage />} />
      <Route path={pageUrl.vouchers} element={<VouchersPage />} />
      <Route element={<ServiceLayout />}>
        <Route path={pageUrl.services} element={<ServiceListPage />} />
        <Route path={pageUrl.bundles} element={<BundleListPage />} />
      </Route>
      <Route path={pageUrl.servicesAdd} element={<ServiceForm />} />
      <Route path={pageUrl.servicesEdit} element={<ServiceForm />} />
    </>
  )
}
